<template>
  <div>
    <div class="page-header">
      <div class="breadcrumb">
        <span class="brand-logo">
          <div   class="logo-icon"><img   src="https://peelo.io/assets/img/peelo/v2.png" alt="Logo"></div>
        </span>
        <span class="breadcrumb-separator">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </span> 
        <span class="breadcrumb-item">Peelochat</span>
        <span class="breadcrumb-separator">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </span>
        <span class="breadcrumb-item active">{{ pageName }}</span>
      </div>
      <div class="header-actions">
        <slot name="actions"></slot>
      </div>
    </div>

    <div class="page-title-section">
      <h1>{{ pageTitle }}</h1>
      <p class="subtitle" v-if="pageSubtitle">{{ pageSubtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    pageName: {
      type: String,
      required: true
    },
    pageTitle: {
      type: String,
      required: true
    },
    pageSubtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* Couleurs WhatsApp */
:root {
  --whatsapp-teal: #25D366;
  --whatsapp-green: #128C7E;
  --whatsapp-light-green: #dcf8c6;
  --whatsapp-blue: #34B7F1;
  --whatsapp-dark: #075E54;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  border-bottom: 1px solid #eee;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
}

.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #888;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #ccc;
}

.breadcrumb-item {
  color: #888;
}

.breadcrumb-item.active {
  color: #37352f;
  font-weight: 500;
}

.brand-logo {
  display: flex;
  align-items: center;
  margin-right: 8px;
  height: 40px;
}

.logo-icon {
  height: 100%;
  display: flex;
  align-items: center;
}

.logo-icon img {
  height: 100%;
  width: auto;
  object-fit: contain;
}

.brand-logo svg {
  stroke: var(--whatsapp-green);
}

.page-title-section {
  padding: 32px 32px 8px;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
}

h1 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  color: var(--whatsapp-dark);
  letter-spacing: -0.025em;
}

.subtitle {
  color: #888;
  margin-top: 8px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .page-header, .page-title-section {
    padding-left: 16px;
    padding-right: 16px;
  }
  
  .breadcrumb {
    display: none;
  }
}
</style> 